// extracted by mini-css-extract-plugin
module.exports = {"content":"termo-de-uso_content__2Pyob"};